import textStyle from "component/toolManager/textStyle.js";
/**
 * Draw multiple lines of text within a bounding box.
 * @public
 * @method fillTextLines
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {Object} boundingBox - `{ left, top }` in canvas coordinates. Only the top-left corner is specified, as the text will take up as much space as it needs.
 * @param {String[]} textLines - The text to be displayed.
 * @param {FillStyle} fillStyle - The fillStyle to apply to the text.
 * @param {Number} padding - The amount of padding above/below each line in canvas units. Note this gives an inter-line spacing of `2*padding`.
 * @returns {undefined}
 */
export default function(context, boundingBox, textLines, fillStyle, padding) {
  let fontSize = textStyle.getFontSize();

  const ratio = Math.max(
    Math.min(context.canvas.height / 20, fontSize) / fontSize,
    0.3
  );
  fontSize = fontSize * ratio;
  const fontFamily = textStyle.getFontFamily();
  context.font = `${fontSize}px "${fontFamily}"`;

  context.textBaseline = "top";
  //context.fillStyle = fillStyle;
  context.fillStyle = textStyle.getFontColor();
  textLines.forEach(function(text, index) {
    context.fillText(
      text,
      boundingBox.left + padding,
      boundingBox.top + padding + index * (fontSize + padding)
    );
  });
}
